import {
  Flex,
  Heading,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import Offer from '../../../types/Offer.interface';
import getOfferLocationsLabel from './getOfferLocationsLabel';

const BusinessCell = ({ offer }: { offer: Offer }) => {
  return (
    <Flex flexDir="column" justify="flex-start">
      <Heading fontSize="lg">{offer.business.name}</Heading>
      <Text fontSize="lg" mt={2}>
        {getOfferLocationsLabel(offer)}
      </Text>
    </Flex>
  );
};

export default BusinessCell;
